export function useWidth(attrWidth, defaultWidth, smallMedia, containerSize) {
    containerSize = containerSize !== null && containerSize !== void 0 ? containerSize : Infinity;
    let width = attrWidth !== null && attrWidth !== void 0 ? attrWidth : defaultWidth;
    let maxWidth = +defaultWidth;
    width = +width;
    if (smallMedia) {
        maxWidth = 500;
    }
    // Keep within bounds
    if (width > containerSize) {
        width = containerSize - 32;
    }
    width = parseInt(`${width}`);
    return {
        maxWidth,
        width
    };
}

//# sourceMappingURL=useWidth.js.map